/** Human-readable location label for spot cards (never render raw coordinate objects). */
export function formatSpotLocation(spot) {
  if (!spot) return "Caribbean";

  if (typeof spot.location === "string" && spot.location.trim()) {
    return spot.location.trim();
  }

  if (spot.formatted_address?.trim()) {
    return spot.formatted_address.trim();
  }

  if (spot.parish && spot.country) {
    return `${spot.parish}, ${spot.country}`;
  }

  if (spot.country) {
    return String(spot.country);
  }

  if (spot.location && typeof spot.location === "object") {
    const { lat, lng } = spot.location;
    if (lat != null && lng != null) {
      return `${Number(lat).toFixed(4)}, ${Number(lng).toFixed(4)}`;
    }
  }

  return "Caribbean";
}
